import React from 'react';
import styles from './styles.scss';

export const LegalCopy =
  'Note: You may only send SMS messages to guests who have agreed to receive updates from you. Available for U.S. phone numbers only.';

const LegalSms: React.FC = () => {
  return <div className={styles.legalCopyContainer}>{LegalCopy}</div>;
};

export default LegalSms;
